module.exports = __webpack_public_path__ + "static/img/hover-iocn60.2abfdb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn60.png
// module id = JjH9
// module chunks = 1